import { axiosInstance } from '../../App';

export function cancelAppointment(appointmentID:number){
    return axiosInstance.get('/api/public/site/cancelAppointment',{
        params:{
            appointmentID:appointmentID
        }
    }).then(res=>res).catch(err=>err)
}

export function getAppointmentInformationForCancel(pcq:string,patientid:string){

    return axiosInstance.post('/api/public/site/getAppointmentInformationForCancel',null,{params:{pcq:pcq,id:patientid}}).then(res=>res).catch(err=>err);

}

export function confirmAppointment(appointmentID:number){
    return axiosInstance.get('/api/public/site/confirmAppointment',{
        params:{
            appointmentID:appointmentID
        }
    }).then(res=>res).catch(err=>err)
}

export function getAppointmentInformationForConfirm(pcq:string,patientid:string){

    return axiosInstance.post('/api/public/site/getAppointmentInformationForConfirm',null,{params:{pcq:pcq,id:patientid}}).then(res=>res).catch(err=>err);

}

export function saveImagesInHC(files: File[], description: string, patient: string, professional: string) {
    const apiUrl = "/api/public/site/saveImagesInHC"; // Ajusta la URL base según tu caso
  
    const formData = new FormData();
  
    for (let i = 0; i < files.length; i++) {
      formData.append("file", files[i]);
    }
  
    return axiosInstance
      .post(`${apiUrl}`, formData, {
        params: {
          description: description,
          patient: patient,
          professional: professional,
        },
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        return response.status;
      })
      .catch((error) => {
        console.error(error);
      });
  }

export function useAppointmentService() {
  return {
    cancelAppointment,
    getAppointmentInformationForCancel,
    confirmAppointment,
    getAppointmentInformationForConfirm,
    saveImagesInHC,
  }
}
